export const goalTrackerApiBaseUrl = process.env.REACT_APP_GOAL_TRACKER_API_BASE_URL;
export const goalTrackerApiKey = process.env.REACT_APP_GOAL_TRACKER_API_KEY;
export const goalTrackerUrlPrefix = process.env.REACT_APP_GOAL_TRACKER_URL_PREFIX || "";
export const goalTrackerPollDelay = process.env.REACT_APP_GOAL_TRACKER_POLL_INTERVAL || 5000;

const appSettings = {
    goalTrackerApiBaseUrl, 
    goalTrackerApiKey, 
    goalTrackerUrlPrefix, 
    goalTrackerPollDelay
};

export default appSettings;